import React from 'react';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-navy text-white pt-8 pb-12 px-4 relative overflow-hidden" data-id="element-95">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-96">
        <div className="flex items-center gap-3 mb-6" data-id="element-97">
          <span className="bg-patriot-red text-white text-xs font-bold px-3 py-1 rounded-sm tracking-wider" data-id="element-98">
            BESTSELLER
          </span>
          <div className="flex text-gold" data-id="element-99">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" className="text-gold" data-id="element-100" />)}
          </div>
        </div>

        <h1 className="text-3xl md:text-5xl font-bold mb-4 leading-tight" data-id="element-101">
          Charlie Kirk: Life, Quotes & Legacy
        </h1>

        <h2 className="text-xl md:text-2xl text-blue-200 mb-2 font-inter font-medium" data-id="element-102">
          The young philosopher who turned a microphone into a movement
        </h2>

        <p className="text-lg text-blue-300 mb-8 italic" data-id="element-103">
          A patriotic voice for America's future
        </p>

        <div className="relative w-full max-w-md mx-auto mt-4" data-id="element-104">
          <div className="absolute -top-4 -right-4 bg-blue-600 text-white text-xs font-bold px-4 py-4 rounded-full w-20 h-20 flex items-center justify-center text-center shadow-lg z-10 border-2 border-navy rotate-12" data-id="element-105">
            NOW
            <br data-id="element-106" />
            AVAILABLE
            <br data-id="element-107" />
            ONLINE
          </div>

          <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-navy-light bg-black" data-id="element-108">
            <img src="https://cdn.magicpatterns.com/uploads/8VhdCTKEB5SoAzmACwizSF/Mockup_Audio_Book_Charlie_Kirk.png" alt="Voices of Freedom Audiobook Bundle" className="w-full h-auto object-cover opacity-90 hover:opacity-100 transition-opacity" data-id="element-109" />
          </div>
        </div>
      </div>
    </section>;
}